import { render } from "./ContractDetail.vue?vue&type=template&id=00742836&scoped=true"
import script from "./ContractDetail.vue?vue&type=script&lang=js"
export * from "./ContractDetail.vue?vue&type=script&lang=js"

import "./ContractDetail.vue?vue&type=style&index=0&id=00742836&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00742836"]])

export default __exports__